import React, { Component } from 'react';

const ulstyle = {}
const tdstyle = { border: '1px solid black', borderCollapse: 'collapse' }

class TooltipInfoCarrier extends Component {

    render() {

        return (
            <div style={{ width: '80%' }} className='TooltipInfoCarrier'>
                <table style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Bewaartermijn</th>
                            <th style={{ border: '1px solid black', borderCollapse: 'collapse' }}>Onderdeel</th>
                        </tr>
                    </thead>
                    <tbody style={{ verticalAlign: 'top' }}>
                        <tr>
                            <td style={tdstyle}><b>Maximaal 2 jaar na einde dienstverband</b></td>
                            <td style={tdstyle}>
                                <ul style={ulstyle}>
                                    <li>Arbeidsovereenkomsten en wijzigingen (vastgelegd in art. 52 Wet Rijksbelastingen)</li>
                                    <li>Correspondentie over benoemingen, promotie, demotie en ontslag (vastgelegd in art. 52 Wet Rijksbelastingen); let op: deze moeten ook minimaal 2 jaar worden bewaard</li>
                                    <li>Verslagen van functioneringsgesprekken (vastgelegd in de AVG); let op: deze moeten ook minimaal 2 jaar worden bewaard.</li>
                                    <li>Verslaglegging in het kader van de Wet Verbetering Poortwachter (vastgelegd in de AVG)</li>
                                    <li>VUT-regeling (vastgelegd in art. 52 Wet Rijksbelastingen)</li>
                                    <li>Afspraken over werkzaamheden voor de OR (vastgelegd in Vrijstellingsbesluit Wbp); let op: maximale bewaartermijn geldt hier 2 jaar na einde lidmaatschap, niet na einde dienstverband</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td style={tdstyle}><b>Maximaal 5 jaar na einde dienstverband</b></td>
                            <td style={tdstyle}>
                                <ul style={ulstyle}>
                                    <li>Loonbelastingverklaringen en kopieën van identiteitsbewijzen (vastgelegd in art. 66 lid 4 Uitvoeringsregeling LB)</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td style={tdstyle}><b>Maximaal 7 jaar na einde dienstverband</b></td>
                            <td style={tdstyle}>
                                <ul style={ulstyle}>
                                    <li>Afspraken over salaris en arbeidsvoorwaarden (vastgelegd in Wet Rijksbelastingen)</li>
                                    <li>Persoonsgegevens werknemers- NAW en Burgerlijke staat (vastgelegd in Wet Rijksbelastingen)</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td style={tdstyle}><b>Bijzondere zaken en hun bewaartermijnen</b></td>
                            <td style={tdstyle}>
                                <ul style={ulstyle}>
                                    <li>Sollicitatiebrieven, - formulieren, correspondentie omtrent de sollicitatie, getuigschriften en verklaring omtrent gedrag</li>
                                    <ul>
                                        <li>Bewaartermijn: maximaal 4 weken zonder toestemming, maximaal 1 jaar met toestemming van de sollicitant</li>
                                        <li>Ingangsdatum bewaartermijn: na beëindiging sollicitatieprocedure</li>
                                        <li>Vastgelegd in: AVG</li>
                                    </ul>
                                    <li>Gegevens over etniciteit en herkomst</li>
                                    <ul>
                                        <li>Bewaartermijn: minimaal 5 jaar, geen maximum</li>
                                        <li>Ingangsdatum: na einde dienstverband</li>
                                        <li>Vastgelegd in: Wet Samen (Wet Stimulering Arbeidsdeelnamen Minderheden)</li>
                                    </ul>
                                    <li>Identiteitspapieren van van derden ingeleende vreemdelingen waarvoor een tewerkstellingsvergunning is verleend</li>
                                    <ul>
                                        <li>Bewaartermijn: minimaal 5 jaar, geen maximum</li>
                                        <li>Ingangsdatum: na afloop van het kalenderjaar waarin arbeid door ingeleende vreemdeling is beëindigd</li>
                                        <li>Vastgelegd in: Wet Arbeid Vreemdelingen</li>
                                    </ul>
                                    <li>Loonbeslagen</li>
                                    <ul>
                                        <li>Bewaartermijn: maximaal tot het moment van opheffing</li>
                                        <li>Vastgelegd in: Vrijstellingsbesluit Wbp</li>
                                    </ul>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div >
        );
    }
}

export default TooltipInfoCarrier;
